import { OverlayTrigger, Tooltip } from "react-bootstrap";
import { TableHeadersType } from "../../../constant/tableHeadersConstants/tableHeadersType";
import { tableEditIcon } from "../../../assets/images";
import {
  formatDate,
  formateDateWithTime,
} from "../../../utils/commonFunctions";
import UpdatedByAndUpdatedAt from "../../commons/CommonUpdatedByAndUpdatedAt";
import TableToggleSwitch from "../../commons/TableToggleSwitch";
import { BatchManagementItem } from "../../../redux/clientSettings/clientSettingTypes";
type AppProps = {
  tableHeaders: TableHeadersType[] | [];
  data: BatchManagementItem[]|[]
  handleRedirectToEditForm: (data: any) => void;
  handleEnableDisableStatus: (data: any) => void;
};
const BatchManagementTableData = ({
  tableHeaders,
  data,
  handleRedirectToEditForm,
  handleEnableDisableStatus,
}: AppProps) => {
  return (
    <>
      {data?.length > 0 &&
        data?.map((batchData: any) => {
          return (
            <tr className="text-left">
              {tableHeaders?.length > 0 &&
                tableHeaders?.map((header: TableHeadersType) => {
                  if (header?.value == "batch_number") {
                    return (
                      <td className="text-left">{batchData?.batch_number}</td>
                    );
                  } else if (header?.value == "expiry_date") {
                    return (
                      <td className="text-left">
                        {batchData?.expiry_date
                          ? formatDate(batchData?.expiry_date)
                          : ""}
                      </td>
                    );
                  } else if (header?.value == "manufacturing_date") {
                    return (
                      <td className="text-left">
                        {batchData?.manufacturing_date
                          ? formatDate(batchData?.manufacturing_date)
                          : ""}
                      </td>
                    );
                  } else if (header?.value === "status") {
                    return (
                      <TableToggleSwitch
                        handleEnableDisableClick={handleEnableDisableStatus}
                        status={batchData?.is_enable === 1 ? true : false}
                        tableData={batchData}
                      />
                    );
                  } else if (header?.value === "updated_by") {
                    return (
                      <td className="text-start" style={{ minWidth: "180px" }}>
                        <UpdatedByAndUpdatedAt
                          firstName={batchData?.updated_by?.first_name}
                          lastName={batchData?.updated_by?.last_name}
                          profilePic={
                            batchData?.updated_by?.profile_pic?.file_url
                          }
                          updatedAt={formateDateWithTime(batchData?.updated_at)}
                        />
                      </td>
                    );
                  } else if (header?.value == "action") {
                    return (
                      <td style={{ width: "50px", textAlign: "start" }}>
                        <span
                          className="d-inline-block pointer"
                          onClick={() => {
                            handleRedirectToEditForm?.(batchData);
                          }}
                        >
                          <div
                            style={{
                              color: "#d43",
                              fontSize: 20,
                            }}
                          >
                            <OverlayTrigger
                              placement="top"
                              delay={{ show: 250, hide: 250 }}
                              overlay={
                                <Tooltip id="button-view-open-item">
                                  Edit
                                </Tooltip>
                              }
                            >
                              <img src={tableEditIcon} alt="" />
                            </OverlayTrigger>
                          </div>
                        </span>
                      </td>
                    );
                  }
                  return null;
                })}
            </tr>
          );
        })}
    </>
  );
};

export default BatchManagementTableData;
